/**
 * @format
 */

import React from 'react';
import { StyleSheet, Text, View, Platform } from 'react-native';

import {
  Advertisement,
  FullCategory,
  FullThumbtackCategory,
  ThumbtackPro,
} from '../../../api/adserver';
import Carousel, { DisplayType } from '../zonecarousel';
import config from '../../config';

export interface Props {
  item: FullCategory | FullThumbtackCategory;
  renderItem: ((item: any) => JSX.Element | null) | null;
  onPress?: (item: Advertisement | ThumbtackPro) => void;
  onPressCategory?: (item: FullCategory | FullThumbtackCategory) => void;
}

const CategoryListItem: React.FC<Props> = (props) => {
  const { item, onPressCategory, onPress, renderItem } = props;
  const items = (item && item.adverts && item.adverts.slice(0, 4)) || [];

  return (
    <>
      <View style={[styles.featureHeadingContainer, styles.sectionStart]}>
        <Text style={styles.featureHeading}>{item.title}</Text>
      </View>
      <Carousel
        name={`caregoryadverts-${item.id}`}
        displayType={DisplayType.adverts}
        items={items}
        renderItem={renderItem}
        onPress={onPress}
        onViewMore={() => {
          if (onPressCategory) {
            onPressCategory(item);
          }
        }}
        showViewMore
      />
    </>
  );
};

const styles = StyleSheet.create({
  scrollView: {
    backgroundColor: '#ffffff',
    marginHorizontal: 10,
  },
  engine: {
    position: 'absolute',
    right: 0,
  },
  featureHeadingContainer: {
    flexDirection: 'row',
    marginBottom: 0,
    justifyContent: 'space-between',
    marginStart: 5,
    marginEnd: config.theme.headingEndMargin,
    ...Platform.select({
      web: {},
      default: {
        flex: 1,
      },
    }),
  },
  sectionStart: {
    marginTop: 23,
    marginBottom: 0,
  },
  featureHeading: {
    fontSize: config.theme.headingFontSize,
    fontWeight: config.theme.headingFontWeight,
    color: config.theme.headingTextColor,
  },
  featureViewAll: {
    fontSize: 14,
    fontWeight: 'bold',
    alignSelf: 'center',
    color: config.theme.headingTextColor,
  },
});

export default CategoryListItem;
